export default "__VITE_ASSET__53f4af05__"